import {
    actionCreator,
    checkHttpStatus, 
    jsonApiHeader, 
    showErrorMessage, 
    showSuccessMessage, 
    showWarningMessage,
    antecedentActionTypes, 
    GET_MASTERDATABYNAME, 
    GET_ANTECEDENT_LIST_API, 
    POST_ANTECEDENT_API, 
    DELETE_ANTECEDENT_API,
    GET_ANTECEDENT_DETAIL_API
} from '../constants/ApiConstants';

import Alert from 'react-s-alert';
import { checkHttpStatusAuthCheck, createSearchUrlForCustomAPI } from '../../../../../../../actions/utilAction';
import { PatientRecordABCDataList } from '../../../../collectData/componnets/BehaviorData/actions/BehaviourDataActions'

export const getMasterData = (masterData) => {
    return (dispatch, getState) => {
        dispatch(actionCreator(antecedentActionTypes.get_masterData.REQUEST));
        fetch(`${GET_MASTERDATABYNAME}`, {
            method: 'post',
            body: JSON.stringify(masterData),
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
        })
            .then((res)=>checkHttpStatusAuthCheck(res,dispatch,getState))
            .then(function (response) {
                dispatch(actionCreator(antecedentActionTypes.get_masterData.SUCCESS, response));
            })
            .catch(function (error) {
                console.log('error getMasterData ..', error);
            });
    };
};

export const getAntecedentsList = (searchObj, patientId) => {
    let query_params = createSearchUrlForCustomAPI(searchObj);
    return (dispatch, getState) => {
        dispatch(actionCreator(antecedentActionTypes.get_antecedentList.REQUEST));
        fetch(`${GET_ANTECEDENT_LIST_API}${query_params}`, {
            method: 'get',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
        })
            .then(checkHttpStatus)
            .then(function (response) {
                if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                    dispatch(actionCreator(antecedentActionTypes.get_antecedentList.SUCCESS, response));
                } else {
                    dispatch(actionCreator(antecedentActionTypes.get_antecedentList.SUCCESS, null));
                }
            }).catch(function (error) {
                console.log('error get_antecedentList', error);
            });
    };
};

export const getAntecedentsListDetails = (reductionId) => {
    return (dispatch, getState) => {
        dispatch(actionCreator(antecedentActionTypes.get_antecedentDetail.REQUEST));
        fetch(`${GET_ANTECEDENT_DETAIL_API}?reductionId=${reductionId}`, {
            method: 'get',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
        })
            .then(checkHttpStatus)
            .then(function (response) {
                if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                    dispatch(actionCreator(antecedentActionTypes.get_antecedentDetail.SUCCESS, response));
                } else {
                    dispatch(actionCreator(antecedentActionTypes.get_antecedentDetail.SUCCESS, null));
                }
            }).catch(function (error) {
                console.log('error get_antecedentDetail', error);
            });
    };
};

export const saveAntecedents = (formProps, patientId) => {
    return (dispatch, getState) => {
        dispatch(actionCreator(antecedentActionTypes.save_antecedent.REQUEST));
        fetch(`${POST_ANTECEDENT_API}`, {
            method: 'POST',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
            body: JSON.stringify(formProps),
        })
            .then(checkHttpStatus)
            .then(function (response) {
                if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                    showSuccessMessage(response.message);
                    dispatch(actionCreator(antecedentActionTypes.save_antecedent.SUCCESS, response));
                    dispatch(PatientRecordABCDataList(patientId))
                } else {
                    showErrorMessage(response.message);
                    dispatch(actionCreator(antecedentActionTypes.save_antecedent.SUCCESS, null));
                }
            })
            .catch(function (error) {
                console.log('error save_antecedent', error);
            });
    };
};

export const deleteAntecedents = (reductionId) => {
    Alert.closeAll();
    return (dispatch, getState) => {
        dispatch(actionCreator(antecedentActionTypes.delete_antecedent.REQUEST));
        fetch(`${DELETE_ANTECEDENT_API}?reductionId=${reductionId}`, {
            method: 'PATCH',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
        })
            .then(checkHttpStatus)
            .then((response) => {
                if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                    showSuccessMessage(response.message);
                    dispatch(actionCreator(antecedentActionTypes.delete_antecedent.SUCCESS, response));
                } else if (response.statusCode === 401 || response.statusCode === 422) {
                    showWarningMessage(response.message);
                    dispatch(actionCreator(antecedentActionTypes.delete_antecedent.SUCCESS, null));
                } else {
                    showErrorMessage(response.message);
                    dispatch(actionCreator(antecedentActionTypes.delete_antecedent.SUCCESS, null));
                }
            }).catch(function (error) {
                console.log('error delete_antecedent', error);
            });
    };
};



// WEBPACK FOOTER //
// ./src/modules/patients/components/DataCollection/BehaviorReductiom/Antecedents/actions/antecedentsActions.js